import React, { useState } from 'react';
import { Button, Paper} from '@material-ui/core';
import { useDispatch } from 'react-redux';

function ComfirmationSuccess({ classes, setNewPaymentMethod }) {
  const dispatch = useDispatch();
  const [sendCode, setSendCode] = useState(true);
  const [code, setCode] = useState(false);

  const handleSubmit = (e) => {
    setNewPaymentMethod(false);
  };

  return (
              <Paper className={classes.paper} elevation={0}>
                  <form onSubmit={handleSubmit}>
                      <p>
                        { 'Please check your email for the confirmation link'}
                      </p>
                      <Button fullWidth className={classes.submitButton} type="submit">
                        {'Back'}
                      </Button>
                  </form>
              </Paper>
  );
}

export default ComfirmationSuccess;
